import UpdateTransaction from './UpdateTransaction'
export default UpdateTransaction
